import React from 'react'

import styles from '../styles/check_algorithm_component.module.scss'
import { HtmlContent } from 'utils'

const MainStep = ({ title, description, contact }) => {
  const {name, image, position} = contact
  
  return (
    <div className={styles.check_algorithm_component__item_main}>
        <div className={styles.check_algorithm_component__item_main_top}>
          {
            title !== ''
              ? <>
                <div className={styles.check_algorithm_component__item_main_pretitle}></div>
                <h2 className={styles.check_algorithm_component__item_main_title}>
                  {title}
                </h2>
              </>
              : null
          }

          {
            description !== ''
              ? <HtmlContent content={description} className={styles.check_algorithm_component__item_main_description}/>
              : null
          }
        </div>
        <div className={styles.check_algorithm_component__item_main_avatar}>
            <img loading="lazy" className={styles.check_algorithm_component__item_main_avatar_img} src={image} alt='' />
          <div className={styles.check_algorithm_component__item_main_avatar_user}>
            <p className={styles.check_algorithm_component__item_main_avatar_user_name}>{name}</p>
            <p className={styles.check_algorithm_component__item_main_avatar_user_position}>
              {position}
            </p>
          </div>
        </div>
      </div>
  )
}

export default MainStep